import "./App.css";
import ProductCard from "./ProductCard";
import desktop from "../src/images/desktop-product.jpg";
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="image-container">
          <img src={desktop} alt="product" />
        </div>
        <div className="product-info">
          <ProductCard />
        </div>
      </header>
    </div>
  );
}

export default App;
